import React from 'react'
import { SliderOnboarding } from '@/components/SliderOnboarding'
import { useProfilePrompt } from '../../useProfilePrompt'
import { RenderItemProps } from '../types'
import { BaseCard } from './BaseCard'

export const WorkConfidenceCard = ({ item }: RenderItemProps) => {
  const prompt = useProfilePrompt(item)

  function onValueChange(value: number | number[]) {
    prompt.form.setFieldValue('confidence_at_work', Array.isArray(value) ? value[0] : value)
  }

  return (
    <BaseCard prompt={prompt}>
      <SliderOnboarding
        {...prompt.form.register('confidence_at_work')}
        onValueChange={onValueChange}
        labelVariants={['h4']}
      />
    </BaseCard>
  )
}
